module.exports = __webpack_public_path__ + "img/credito-2.15b4d177.webp";